import AxiosHttp from './_http';
import AxiosLambda from './_lambda';

const http = new AxiosHttp().axios;
const lambda = new AxiosLambda().axios;

export {http, lambda};
